import { validAllAuditQuestions } from "../services/request-manager"



export const validAllQuestions = (idValutation) => {
    return validAllAuditQuestions(idValutation)
}